<div class="mm-cc" *ngIf="visible" role="dialog" aria-live="polite"
     [attr.aria-label]="lang.isArabic ? 'إشعار ملفات تعريف الارتباط' : 'Cookie notice'">
  <div class="mm-cc-inner">
    <div class="mm-cc-icon" aria-hidden="true"><i class="fa fa-shield"></i></div>

    <div class="mm-cc-text">
      <h4 class="mm-cc-title">{{ lang.isArabic ? 'نحن نحترم خصوصيتك' : 'We value your privacy' }}</h4>
      <p class="mm-cc-desc">
        {{ lang.isArabic
          ? 'نستخدم ملفات تعريف الارتباط لتحسين تجربتك وتحليل استخدام الموقع. يمكنك القبول أو الرفض في أي وقت.'
          : 'We use cookies to improve your experience and analyze site usage. You can accept or reject at any time.' }}
      </p>
    </div>

    <div class="mm-cc-actions">
      <button type="button" class="mm-cc-btn mm-cc-btn-ghost" (click)="reject()">
        {{ lang.isArabic ? 'رفض' : 'Reject' }}
      </button>
      <button type="button" class="mm-cc-btn mm-cc-btn-primary" (click)="accept()">
        {{ lang.isArabic ? 'قبول الكل' : 'Accept all' }}
      </button>
    </div>
  </div>
</div>
